// @ts-check
/** Toggle mobile nav */

if (!window.AndDaughter) {
  window.AndDaughter = {};
}

window.AndDaughter.mobileNav = function () {
  /**
   * @var {HTMLElement}
   */
  const toggleButton = document.querySelector('[aria-controls="mb-Nav"]');

  /**
   * @var {HTMLElement}
   */
  const backButton = document.querySelector("[data-js-back-button]");

  /**
   * @var {HTMLElement}
   */
  const menuTitle = document.querySelector("[ds-js-menu-title]");

  /**
   * @var {HTMLElement}
   */
  const mobileNav = document.querySelector(
    '[aria-labelledby="mb-Nav_Button"]'
  );

  /**
   * @var {NodeListOf<HTMLElement> | undefined}
   */
  const childLinks = mobileNav?.querySelectorAll("[data-has-children]");

  /**
   * @var {NodeListOf<HTMLElement> | undefined}
   */
  const childSections = mobileNav?.querySelectorAll(".mb-Nav_Children");


  /**
   * @var {NodeListOf<HTMLElement> | undefined}
   */
  const grandchildLinks = mobileNav?.querySelectorAll("[data-has-grandchildren='true']");

  /**
   * @var {NodeListOf<HTMLElement> | undefined}
   */
  const grandchildSections = mobileNav?.querySelectorAll(".mb-Nav_Grandchildren");


  /**
   * @var {Record<string, string>}
   * A list of classes used as CSS styling hooks
   */
  const classes = {
    isActive: "is-mb-Nav",
    isChildActive: "is-mb-ChildNav",
    isGrandchildActive: "is-mb-GrandchildNav",
  };

  /**
   *
   *
   * @return {void}
   */
  const resetMenuTitle = () => {
    menuTitle.innerHTML = menuTitle?.getAttribute("ds-js-menu-title");
    menuTitle?.removeAttribute("data-previous-child-title");
  };

  /**
   * Go back to top level nav links e.g. hide children
   *
   * @return {void}
   */
  const handleBack = () => {
    if (document.documentElement.classList.contains(classes.isGrandchildActive)) {
      document.documentElement.classList.remove(classes.isGrandchildActive);
      menuTitle.textContent = menuTitle?.getAttribute("data-previous-child-title") || "";
      closeAllGrandchildSections();
    } else {
      closeAllChildSections();
      document.documentElement.classList.remove(classes.isChildActive);
      toggleButton?.focus();
      resetMenuTitle();
    }
  };

  /**
   * Make sure all buttons/child links are reset (i.e. hidden)
   *
   * @return {void}
   */
  const closeAllChildSections = () => {
    if (childSections) {
      for (let i = 0; i < childSections.length; i++) {
        childSections[i].setAttribute("aria-hidden", "true");
        childSections[i].setAttribute("hidden", "true");
      }
    }

    if (childLinks) {
      for (let i = 0; i < childLinks.length; i++) {
        childLinks[i].setAttribute("aria-expanded", "false");
      }
    }
  };

  /**
 * Make sure all buttons/child links are reset (i.e. hidden)
 *
 * @return {void}
 */
  const closeAllGrandchildSections = () => {
    if (grandchildSections) {
      for (let i = 0; i < grandchildSections.length; i++) {
        grandchildSections[i].setAttribute("aria-hidden", "true")
        grandchildSections[i].setAttribute("hidden", "true")
      }
    }

    if (grandchildLinks) {
      for (let i = 0; i < grandchildLinks.length; i++) {
        grandchildLinks[i].setAttribute("aria-expanded", "false")
      }
    }
  };


  /**
   * Close the nav
   *
   * @return {void}
   */
  const close = () => {
    toggleButton?.setAttribute("aria-expanded", "false");
    mobileNav?.setAttribute("aria-hidden", "true");
    mobileNav?.setAttribute("hidden", "true");
    document.documentElement.classList.remove(classes.isActive);
    document.documentElement.classList.remove(classes.isChildActive);
    document.documentElement.classList.remove(classes.isGrandchildActive);
    closeAllChildSections();
    resetMenuTitle();
  };

  /**
   * Open the nav
   *
   * @return {void}
   */
  const open = () => {
    toggleButton?.setAttribute("aria-expanded", "true");
    mobileNav?.removeAttribute("aria-hidden");
    mobileNav?.removeAttribute("hidden");
    document.documentElement.classList.add(classes.isActive);

    // stop the add to bag button sitting on top of the menu
    if (window.AndDaughter.productButtonScroll) {
      window.AndDaughter.productButtonScroll().unstick();
    }

    // Close the open cart
    if (window.AndDaughter.cartDrawer) {
      window.AndDaughter.cartDrawer().close();
    }
  };

  /**
   * Shop/hide top-level mobile nav
   *
   * @param {Event} event
   * @return {void}
   */
  const toggle = (event) => {
    event.preventDefault();
    const isActive =
      toggleButton?.getAttribute("aria-expanded")?.toString() === "true";

    if (isActive) {
      close();
    } else {
      open();
    }
  };

  /**
   * Shop hide child-level mobile nav
   *
   * @param {Event} event
   * @return {void}
   */
  const toggleChild = (event) => {
    event.preventDefault();

    const button = event.currentTarget;
    if (button) {
      const isExpanded = button.getAttribute("aria-expanded");

      const childNav = document.querySelector(
        `#${button.getAttribute("aria-controls")}`
      );

      if (isExpanded === "false") {
        if (event.currentTarget.dataset?.hasGrandchildren === "true") {
          document.documentElement.classList.add(classes.isGrandchildActive);
          menuTitle?.setAttribute("data-previous-child-title", menuTitle?.textContent?.trim() || "");
        } else {
          document.documentElement.classList.add(classes.isChildActive);
        }
        menuTitle.innerHTML = button.innerHTML;
      }

      button.setAttribute("aria-expanded", !isExpanded.toString());

      if (childNav?.getAttribute("aria-hidden") === "true") {
        childNav.removeAttribute("aria-hidden");
        childNav.removeAttribute("hidden");
      } else {
        childNav?.setAttribute("aria-hidden", "true");
        childNav?.setAttribute("hidden", "true");
      }
    }
  };

  /**
   * Add and remove event listeners that will trigger actions on the elements
   *
   * @returns {void}
   */
  const addEventListeners = () => {
    toggleButton?.removeEventListener("click", toggle);
    toggleButton?.addEventListener("click", toggle);

    backButton?.removeEventListener("click", handleBack);
    backButton?.addEventListener("click", handleBack);

    if (childLinks) {
      for (let i = 0; i < childLinks.length; i++) {
        childLinks[i].removeEventListener("click", toggleChild);
        childLinks[i].addEventListener("click", toggleChild);
      }
    }
  };

  /**
   * Scripts/tasks that run when object is first created
   *
   * @returns {void}
   */
  const init = () => {
    addEventListeners();
  };

  return {
    init,
  };
};

window.AndDaughter.mobileNav().init();
